import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import LoadingPage from '../pages/error-pages/LoadingPage.jsx';
import { UserAuth } from '../authentication/AuthContext.jsx';
import { getGameRegistriesByOrgIdWithAccessibility } from '../services/admin-settings/GameService.jsx';
import { gameEntryPath } from './onboardingSteps.js';

// The one game the user can open in the current org (its Homepage, or its wizard while in setup), else the games list.
export const landingPathFor = (catalogue) => {
    const open = (Array.isArray(catalogue) ? catalogue : []).filter((g) => g?.id && g.accessible);
    return open.length === 1 ? gameEntryPath(open[0]) : '/game';
};

// LANDING_PATH: reads the current org's games after any reload, so a game granted a moment ago counts.
const LandingRedirect = () => {
    const { user } = UserAuth();
    const orgId = useSelector((state) => state.dashboardContext?.selectedOrgId);
    const [target, setTarget] = useState(null);

    useEffect(() => {
        if (!user?.accessToken) return undefined;
        if (!orgId) {
            setTarget('/game');
            return undefined;
        }
        let cancelled = false;
        getGameRegistriesByOrgIdWithAccessibility({ orgId, accessToken: user.accessToken })
            .then((resp) => (resp?.games || []).map((item) => ({ ...item.game, accessible: !!item.accessible })))
            .then((games) => { if (!cancelled) setTarget(landingPathFor(games)); })
            .catch(() => { if (!cancelled) setTarget('/game'); });
        return () => { cancelled = true; };
    }, [user?.accessToken, orgId]);

    return target ? <Navigate to={target} replace /> : <LoadingPage />;
};

export default LandingRedirect;
